<script setup lang="ts">
import { UserIcon } from '@heroicons/vue/24/outline'
import { highlight } from '@/utils/highlight'
import type { OsContactResult } from '@/api/omnisearchApi'

const props = defineProps<{
  item: OsContactResult
  query: string
}>()

const emit = defineEmits<{ navigate: [] }>()

function handleClick() {
  emit('navigate')
  window.location.href = `/dashboard/contacts/${props.item.uuid}`
}

const fullName = (c: OsContactResult) =>
  [c.firstname, c.lastname].filter(Boolean).join(' ') || '—'
</script>

<template>
  <button
    class="w-full flex items-start gap-3 px-3 py-2.5 rounded-lg hover:bg-base-200 transition-colors text-left group cursor-pointer"
    @click="handleClick"
  >
    <span class="mt-0.5 flex-shrink-0 w-8 h-8 rounded-md bg-violet-100 dark:bg-violet-900/30 flex items-center justify-center">
      <UserIcon class="w-4 h-4 text-violet-600 dark:text-violet-400" />
    </span>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium truncate text-base-content" v-html="highlight(fullName(item), query)" />
      <div class="flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
        <span v-if="item.email" class="text-xs text-base-content/60" v-html="highlight(item.email, query)" />
        <span v-if="item.phone" class="text-xs text-base-content/60" v-html="highlight(item.phone, query)" />
        <span v-if="item.mobile" class="text-xs text-base-content/60" v-html="highlight(item.mobile, query)" />
        <span v-if="item.company?.name" class="text-xs text-base-content/40">{{ item.company.name }}</span>
      </div>
    </div>
    <span class="text-xs text-base-content/40 self-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">→</span>
  </button>
</template>
